import React from 'react';
import AdGuard from './AdGuard';

const FAQs = () => {
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h1>Frequently Asked Questions</h1>
      <AdGuard adSlot="" />

      <h3>Q: Are my files uploaded to a server?</h3>
      <p>
        A: No — by default most tools process files in your browser. Files are read into memory and
        the output is generated locally. You must explicitly download or share any output file.
      </p>

      <h3>Q: What formats are supported?</h3>
      <p>
        A: The app supports common PDF tasks and conversions such as image-to-PDF, text-to-PDF,
        Excel-to-PDF (sheet export), and basic edits. The exact set depends on the individual
        tool components included in the site.
      </p>

      <h3>Q: Is there a file size limit?</h3>
      <p>
        A: Limits depend on your browser and available memory. Very large PDFs may be slow or
        cause memory issues; for heavy workloads a server-side pipeline is recommended.
      </p>

      <h3>Q: Can I use this in production or integrate it into my app?</h3>
      <p>
        A: Yes — the components are modular and you can reuse them in your own React projects.
        If you need server-side features (batch processing, cloud storage), consider adding a
        backend.
      </p>

      <h3>Q: How do I report bugs or request features?</h3>
      <p>
        A: Use the Contact page to send a message, or create an issue in the repository (if public).
      </p>

      <h3>Q: How do I get the best results when converting?</h3>
      <p>
        A: Use high-resolution images and avoid corrupted or password-protected PDFs. When
        converting spreadsheets, format the sheet before conversion (set column widths and basic
        styling) for a cleaner export.
      </p>

      <h3>Q: Is this safe for sensitive documents?</h3>
      <p>
        A: Client-side processing reduces exposure, but always weigh the risk. If documents are
        highly sensitive, use a vetted internal tool or a secure server-side workflow with
        appropriate access controls.
      </p>
    </div>
  );
};

export default FAQs;
